module.exports = "<svg id=\"d2885b26-bc31-404b-85bb-d6400b3cf9f8\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>dollar</title><path d=\"M39.82,33.91c0-13-18.75-12-18.75-18.6,0-2,1.56-3.59,4.53-3.59a9.53,9.53,0,0,1,7.65,3.75l5.47-6.56c-1.09-1.41-4.22-3.75-8.9-4.53V0h-8V4.69c-5.94,1.56-9.69,6.09-9.69,11.4,0,12.82,18.75,12,18.75,18.44,0,2.19-1.72,3.91-5.31,3.91-5,0-8.44-3.13-10.32-4.85l-5,7.35c1.25,1.4,5.16,4.22,11.57,4.84V50h7.81V45.31C36.38,43.75,39.82,38.91,39.82,33.91Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dollar.svg
// module id = 559
// module chunks = 1